import List from './list';
import Item from './item';

List.Item = Item;

export default List;